module.exports = __webpack_public_path__ + "static/media/secietypic03.573ee633.png";